import { MutationTree } from "vuex";
import { IReference, IState } from "./types";

export const mutations: MutationTree<IState> = {
    SET_ALBUMS(state: IState, albums: any) {
        state.albums = albums;
    },
    SET_SCROLL_POSITION(state: IState, position: number) {
        state.scrollPosition = position;
    },
    SET_CURRENT_MEDIA_INDEX(state: IState, index?: number) {
        state.currentMediaIndex = index || 0;
    },
    SET_MEDIAS_TO_SHOW(state: IState, album: IReference[]) {
        state.mediasToShow = album;
    },
    SET_IS_GALLERY_OPEN(state: IState, isOpen: boolean) {
        state.isGalleryOpen = isOpen;
    },
    SET_INITIALIZED_SITE_DATA(state: IState, data: any) {
        state.albums = data.albums;
        state.openingHours = data.openingHours;
        state.addresses = data.addresses;
    }
};
